import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import React from 'react'
import Loading from '../../customs/Loading/Loading'
import { EKOM_LINKS } from '../../EKOM_LINKS'
import { useContractSubmsInfoExtSys } from '../../hooks/useContractSubmsInfoExtSys'
import Error from '../../parts/Error'
import Info from '../../parts/Info'
import EkomContractActions from '../EkomContractActions/EkomContractActions'
import { useStyles } from './styles'

interface iEkomContractVirtual {
  canCreateMsg?: boolean
}

const EkomContractVirtual = ({ canCreateMsg }: iEkomContractVirtual) => {
  const classes = useStyles()

  const queryParameters = new URLSearchParams(window.location.search)
  const extObjectId = queryParameters.get(EKOM_LINKS.queryExtId)
  const extSystemId = queryParameters.get(EKOM_LINKS.queryExtSys)

  if (!extSystemId || !extObjectId) {
    return <Info>Neveřejná zakázka nemá indentifikator systému nebo id zakázky z externího systému</Info>
  }

  const { data, loading, error } = useContractSubmsInfoExtSys(extSystemId, extObjectId)

  if (error) {
    return <Error>{error}</Error>
  }
  if (loading) {
    return <Loading/>
  }

  const lhutaNabidek = data?.lhutaNabidkaNavrh
  const lhutaZadost = data?.lhutaZadost

  const zadavatelAdresa = data?.zadavatel.adresa
  return (
    <>
      <h1 className={classes.title}>Externí zakázka - {data?.nazev}</h1>

      <EkomContractActions extSystemId={extSystemId} extObjectId={extObjectId} canCreateMsg={canCreateMsg}
                           ekomunikaceEnabled={true}/>

      <Box p={1}>
        <div className={classes.subtitle}>
          <h2 className={classes.titleInherit}>Základní údaje</h2>
        </div>

        <Grid container className={classes.box}>
          <Grid item sm={12}>
            <strong className={classes.minTitle}>Popis zakázky:</strong>
            <p className={classes.text}>{data?.popis || 'Neuvedeno'}</p>
          </Grid>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Zadavatel</strong>
            <div className={classes.text}>
              {data?.zadavatel.nazev}
            </div>
          </Grid>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Lhůta pro podání nabídek</strong>
            <div className={classes.text}>
              {lhutaNabidek
                ? moment(lhutaNabidek).format('DD. MM. YYYY HH:mm')
                : 'Neuvedeno'}
            </div>
          </Grid>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Lhůta pro žádost o účast</strong>
            <div className={classes.text}>
              {lhutaZadost
                ? moment(lhutaZadost).format('DD. MM. YYYY HH:mm')
                : 'Neuvedeno'}
            </div>
          </Grid>

          <Grid item sm={4}>
            <strong className={classes.minTitle}>Datum zahájení zadávacího řízení</strong>
            <div className={classes.text}>
              {moment(data?.datumZahajeni).format('DD. MM. YYYY')}
            </div>
          </Grid>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Odkaz do externího systému</strong>
            <div className={classes.text}>
              {data?.externiUrl ? (
                <b>
                  <a href={data?.externiUrl + '?auth=1'} target="_blank" rel="noreferrer noopener">
                    {data?.externiUrl}
                  </a>
                </b>
              ) : (
                'Neuvedeno'
              )}
            </div>
          </Grid>

        </Grid>

        <div className={classes.subtitle}>
          <h2 className={classes.titleInherit}>Údaje o zadavateli</h2>
        </div>
        <Grid container className={classes.box}>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Název:</strong>
            <p className={classes.text}>{data?.zadavatel?.nazev || 'Neuvedeno'}</p>
          </Grid>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>IČO:</strong>
            <p className={classes.text}>{data?.zadavatel?.ico || 'Neuvedeno'}</p>
          </Grid>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Adresa:</strong>
            <p
              className={classes.text}>{zadavatelAdresa?.uplnaText || `${zadavatelAdresa?.ulice || ''} ${zadavatelAdresa?.cisloPopisne || ''}${zadavatelAdresa?.cisloOrientacni ? `/${zadavatelAdresa?.cisloOrientacni}` : ''}, ${zadavatelAdresa?.psc || ''} ${zadavatelAdresa?.obec || ''}` || 'Neuvedeno'}</p>
          </Grid>
        </Grid>

        <div className={classes.subtitle}>
          <h2 className={classes.titleInherit}>Ostatní údaje</h2>
        </div>
        <Grid container className={classes.box}>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Fáze zakázky:</strong>
            <p className={classes.text}>{data?.stav}</p>
          </Grid>

          <Grid item sm={4}>
            <strong className={classes.minTitle}>Druh zakázky:</strong>
            <p className={classes.text}>{data?.druhVZ}</p>
          </Grid>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Druh zadávacího řízení:</strong>
            <p className={classes.text}>{data?.druhZR}</p>
          </Grid>
          <Grid item sm={4}>
            <strong className={classes.minTitle}>Číslo na profilu:</strong>
            <p className={classes.text}>{data?.cisloNaProfilu}</p>
          </Grid>
        </Grid>

      </Box>
    </>
  )
}

export default EkomContractVirtual
